import React from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { onlyMoney } from 'hooks/Pipe';

//reemplazando valores de iniciales en estado

export default function ModalPaymentTerm(props) {
  const paymentTerm = props.model;

  return (
    <Modal
      title="Término de pago"
      model={paymentTerm}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="base/payment-term"
      state
    >
      <TextField
        label="Nombre"
        type="text"
        fullWidth
        name="PymntGroup"
        margin="normal"
        defaultValue={paymentTerm?.PymntGroup || ''}
        required
      />
      <TextField
        label="Días extra"
        type="number"
        fullWidth
        name="ExtraDays"
        margin="normal"
        defaultValue={paymentTerm.ExtraDays || ''}
        inputProps={{ min: 0 }}
        required={!paymentTerm.id}
      />
      <TextField
        label="Interés"
        type="number"
        fullWidth
        name="interest_rate"
        margin="normal"
        defaultValue={paymentTerm?.interest_rate || ''}
        inputProps={{ min: 0, max: 100 }}
        onKeyPress={onlyMoney}
        required={!paymentTerm.id}
      />
    </Modal>
  );
}
